import React, { Component } from 'react'
import Modal from '../components/Modal'
import CustomLoader from '../components/CustomLoader'
import FormViewer from '../components/FormViewer'
import ButtonAnimated from '../components/buttons/ButtonAnimated'
import { translate } from '../utils/useful'

export default class LookupAddNewModal extends Component {
    submit = () => {
        let data = this.form.getForm()
        if (this.props.submit && data) {
            this.props.submit(this.props.lookUpInputInfo, data)
        }
    }
    render() {
        return (
            <div className='w-100'>
                <Modal ref={el => this.modal = el} maxWidth={450}>
                    <div className="w-100  " style={{ backgroundColor: '#fff', borderRadius: 8, minHeight: 300 }}>
                        {!this.props.isLoadingFetch ? (

                            <div className='py-2'>
                                {/* {console.log('this.props.lookUpHeaders', this.props.lookUpInputInfo)} */}
                                <FormViewer width={100} ref={el => this.form = el} headers={this.props.lookUpInputInfo?.fields} formClass="modern" inputClass={'modern-input'} />
                                <div className='flexc px-2 justify-content-end'>
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={this.submit}
                                        title={translate('submit')}
                                        icon='/assets/icons/plus-white.svg'
                                        textColor={this.props.colors?.textColor ?? '#fff'}
                                        invert={this.props.colors?.iconInvert}
                                        bg={this.props.colors ? (this.props.colors.background ?? 'linear-gradient(90deg, #5856d6, #7c7aff)') : 'linear-gradient(90deg, #5856d6, #7c7aff)'}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className='h-100 w-100 flexcc pt-5' style={{}}>
                                <p className='mrd-2'>Loading...</p>
                                <CustomLoader color="#ff8500" isLoading={true} />
                            </div>
                        )}
                    </div>
                </Modal>
            </div>
        )
    }
}
